"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function SecurityCommandCentreGreyMultitoneFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__security-command-centre-grey-multitone-filled__clip0_19306_5288)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M8.585.58L2.682 2.02l-.377 8.024 2.492 3.764L8.585 16l3.74-2 2.275-3.304V2.02L8.585.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M2.816 1.77l-.542.584 5.889 5.583.542-.583L2.816 1.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.705 7.47l-.792.026.255 8.152.792-.026-.255-8.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M14.067 1.596L8.164 7.361l.55.575 5.904-5.765-.551-.575z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6C6C6",
    d: "M8.474 11.108c1.847 0 3.344-1.511 3.344-3.376 0-1.864-1.497-3.376-3.344-3.376-1.847 0-3.344 1.512-3.344 3.376 0 1.865 1.497 3.376 3.344 3.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.474 11.508c-2.06 0-3.74-1.692-3.74-3.776 0-2.084 1.676-3.776 3.74-3.776 2.065 0 3.74 1.692 3.74 3.776 0 2.084-1.675 3.776-3.74 3.776zm0-6.748c-1.624 0-2.948 1.336-2.948 2.976s1.324 2.976 2.948 2.976c1.625 0 2.948-1.336 2.948-2.976S10.1 4.76 8.474 4.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.474.892c.908.432 3.344 1.484 5.682 1.556v7.104c0 .804-.266 1.568-.765 2.212-.467.6-1.862 2.1-4.92 3.372-3.06-1.272-4.454-2.776-4.922-3.372a3.582 3.582 0 01-.764-2.212V2.448C5.122 2.372 7.543 1.332 8.466.892m0-.892S5.332 1.652 2.527 1.652c-.178 0-.353-.008-.527-.02v7.92c0 .972.32 1.92.931 2.704.868 1.116 2.65 2.592 5.543 3.744 2.893-1.148 4.676-2.628 5.543-3.744.61-.784.931-1.732.931-2.704v-7.92a5.8 5.8 0 01-.527.02C11.621 1.652 8.474 0 8.474 0h-.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M8.43 9.164c.784 0 1.42-.641 1.42-1.432 0-.79-.636-1.432-1.42-1.432-.783 0-1.418.641-1.418 1.432 0 .79.635 1.432 1.419 1.432z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__security-command-centre-grey-multitone-filled__clip0_19306_5288"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H12.952V16H0z",
    transform: "translate(2)"
  }))));
}

SecurityCommandCentreGreyMultitoneFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
SecurityCommandCentreGreyMultitoneFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = SecurityCommandCentreGreyMultitoneFilled;
exports["default"] = _default;